import React from "react";
import ParagraphTag from "../reusebale/Paragraph";
import moment from "moment";

const BroadCastPopup = ({ onBack, detailData }) => {
  return (
    <main className="w-full h-screen backdrop-blur-sm bg-black/80 fixed inset-0 z-50 flex items-center justify-center">
      <section className="w-[90%] sm:w-[65%] md:w-[50%] lg:w-[40%] xl:w-[40%] bg-texture myshades rounded-[31px] mx-auto">
        <div class="bg-white py-8 lg:py-5 rounded-xl justify-center items-center flex flex-col">
          <div>
            <ParagraphTag
              content="BroadCast Details"
              classes={`text-darkColor font-popinsSemiBold text-base `}
            />
          </div>
          <div className="w-[90%] mx-auto pt-5">
            <div className="flex">
              <div className="w-[49%]">
                <ParagraphTag
                  content="Title"
                  classes={`text-darkColor font-popinsSemiBold text-sm `}
                />
                <ParagraphTag
                  content={detailData?.title}
                  classes={`text-darkColor/60 font-popinsMedium text-sm `}
                />
              </div>
              <div className="w-[49%]">
                <ParagraphTag
                  content="Date"
                  classes={`text-darkColor font-popinsSemiBold text-sm `}
                />
                <ParagraphTag
                  content={moment(detailData?.createdAt).format(
                    "MM/DD/YYYY, h:mm A"
                  )}
                  classes={`text-darkColor/60 font-popinsMedium text-sm `}
                />
              </div>
            </div>
            <div className="w-full pt-4">
              <ParagraphTag
                content="Description"
                classes={`text-darkColor font-popinsSemiBold text-sm `}
              />
              <ParagraphTag
                content={detailData?.description}
                classes={`text-darkColor/60 font-popinsMedium text-sm `}
              />
            </div>
            <p className="text-center font-popinsSemiBold text-black cursor-pointer pt-5 text-sm" onClick={onBack}>
                Close
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BroadCastPopup;
